import React from 'react'
import "./Todo.css";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Product from './Product';
import { productData, responsive } from "./data";
// import Carousel from "react-multi-carousel";
// import "react-multi-carousel/lib/styles.css";

const Todo = () => {
    
      const product = productData.map((item) => (
        <Product name={item.name} url={item.imageurl} price={item.price} description={item.description} />
      ));


  return (
    <div className='App'>
      <div className="title">
                <br></br><br></br><br></br>
        <h1>Somnath Polytex Presents</h1>
        <br></br>
              <h2>Woven Fabric Rolls & Bags</h2>
              </div>
              <br></br>
        <Carousel showDots={true} responsive={responsive}>
 
 {product}
</Carousel>
      
    </div>
  )
}

export default Todo
